import { useTitle } from "@/hooks/useTitle";
import { setBreadcrumb } from "@/store/actions";
import { clearPage } from "@/store/base/actions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

const Page = ({
  children,
  title,
  metaTitle = '',
  metaTitleSuffix = 'HoldYou',
  isClearPage,
  slug,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!!title) {
      const breadCrumbItems = {
        title,
      };
      dispatch(setBreadcrumb(breadCrumbItems));
    }
  }, [dispatch, title]);

  useEffect(() => {
    return () => !!slug && isClearPage && dispatch(clearPage(slug));
  }, [dispatch, slug, isClearPage]);

  useTitle({ title: metaTitle, suffix: metaTitleSuffix });

  return (
    <>
      {children}
    </>
  );
};

export default Page;